import { useEffect } from "react";
import { useForm } from "@inertiajs/react";
import ProductForm from "@/pages/products/product-form";
import { buildProductFormData } from "@/pages/products/form-utils";
import { handleDrawerSuccess, hasArrayErrors, hasMatchingId } from "@/lib/drawer-submission";
import { product_path } from "@/routes";

export default function ProductEditDrawer({ product, errors = [], onSuccess, onProcessingChange = null, updatePath = null }) {
  const { data, setData, patch, processing } = useForm(buildProductFormData(product));

  useEffect(() => {
    setData(buildProductFormData(product));
  }, [product, setData]);

  useEffect(() => {
    onProcessingChange?.(processing);
  }, [onProcessingChange, processing]);

  const submit = (event) => {
    event.preventDefault();
    patch(updatePath || product_path(product.id), {
      preserveScroll: true,
      onSuccess: (page) => handleDrawerSuccess(
        page,
        (props) => (
          props.show_edit_drawer ||
          (
            hasArrayErrors(props, "errors") &&
            (hasMatchingId(props, "edit_product_id", product.id) || hasMatchingId(props, "product", product.id))
          )
        ),
        onSuccess
      ),
    });
  };

  return (
    <ProductForm
      data={data}
      setData={setData}
      errors={errors}
      processing={processing}
      onSubmit={submit}
      submitLabel="Gem ændringer"
      layout="drawer"
    />
  );
}
